document.addEventListener("DOMContentLoaded", () => {
  const HOVER_SELECTOR = ".p-itemBottom__quickAdd";
  const HOVER_MESSAGE = "カートに追加";
  const TOAST_MESSAGE = "カートに追加しました";

  function baseBubbleStyle() {
    return {
      position: "absolute",
      bottom: "calc(100% + 8px)",
      left: "50%",
      transform: "translateX(-50%) translateY(4px)",
      display: "inline-block",
      boxSizing: "border-box",
      padding: "6px 8px",
      fontSize: "12px",
      lineHeight: "1",
      color: "#fff",
      borderRadius: "6px",
      whiteSpace: "nowrap",
      pointerEvents: "none",
      opacity: "0",
      transition: "opacity .18s ease, transform .18s ease",
      zIndex: "999",
    };
  }
  function ensureRelPos(el) {
    if (getComputedStyle(el).position === "static")
      el.style.position = "relative";
  }

  // ルートごとに1つのバブルを作成し、「カートに追加」の幅で固定する
  function ensureBubble(rootEl) {
    if (!rootEl) return null;
    if (rootEl._qaTip) return rootEl._qaTip;

    ensureRelPos(rootEl);

    const tip = document.createElement("div");
    tip.textContent = HOVER_MESSAGE;
    Object.assign(tip.style, baseBubbleStyle(), {
      background: "rgba(0,0,0,.85)",
    });
    rootEl.appendChild(tip);

    // 基準幅を計測して保存
    const width = tip.offsetWidth;
    rootEl._qaWidth = width;
    tip.style.width = width + "px";
    tip.style.maxWidth = width + "px";
    tip.style.minWidth = width + "px";

    rootEl._qaTip = tip;
    return tip;
  }

  // PCホバー時の表示/非表示（トースト中は無効）
  if (window.matchMedia("(hover:hover) and (pointer:fine)").matches) {
    function showTip(rootEl) {
      const tip = ensureBubble(rootEl);
      if (!tip || tip.classList.contains("is-toast")) return;
      tip.textContent = HOVER_MESSAGE;
      tip.style.background = "rgba(0,0,0,.85)";
      tip.style.width = rootEl._qaWidth + "px";
      tip.style.maxWidth = rootEl._qaWidth + "px";
      tip.style.minWidth = rootEl._qaWidth + "px";
      requestAnimationFrame(() => {
        tip.style.opacity = "1";
        tip.style.transform = "translateX(-50%) translateY(0)";
      });
    }
    function hideTip(rootEl) {
      const tip = rootEl && rootEl._qaTip;
      if (!tip || tip.classList.contains("is-toast")) return;
      tip.style.opacity = "0";
      tip.style.transform = "translateX(-50%) translateY(4px)";
    }

    document.addEventListener("mouseover", (e) => {
      const root = e.target.closest && e.target.closest(HOVER_SELECTOR);
      if (!root) return;
      if (root.contains(e.relatedTarget)) return;
      showTip(root);
    });
    document.addEventListener("mouseout", (e) => {
      const root = e.target.closest && e.target.closest(HOVER_SELECTOR);
      if (!root) return;
      if (root.contains(e.relatedTarget)) return;
      hideTip(root);
    });
  }

  // 追加完了トースト表示
  function showCartToastAtButton(btn, message = TOAST_MESSAGE) {
    const root =
      btn.closest(HOVER_SELECTOR) ||
      btn.closest(".p-itemBottom__quickAddForm") ||
      btn.parentElement;
    const tip = ensureBubble(root);
    if (!tip) return;

    tip.classList.add("is-toast");
    tip.textContent = message;
    tip.style.background = "#ff7b7d"; // 追加完了時の色
    tip.style.width = "134px"; // トースト時の幅
    tip.style.maxWidth = "134px";
    tip.style.minWidth = root._qaWidth + "px";

    requestAnimationFrame(() => {
      tip.style.opacity = "1";
      tip.style.transform = "translateX(-50%) translateY(0)";
    });

    setTimeout(() => {
      tip.style.opacity = "0";
      tip.style.transform = "translateX(-50%) translateY(4px)";
      setTimeout(() => {
        tip.classList.remove("is-toast");
        // 文言を元に戻す
        tip.textContent = HOVER_MESSAGE;
        tip.style.background = "rgba(0,0,0,.85)";
      }, 220);
    }, 2000);
  }

  // カート追加処理 (Add To Cart)
  document.addEventListener("click", async (e) => {
    // .js-add-to-cart-button がクリックされた時のみ発火
    const btn = e.target.closest(".js-add-to-cart-button");
    if (!btn) return;

    // ★ Quick Addボタンかどうかをチェック
    // 商品一覧ページの「カートに追加」ボタン（p-itemBottom__quickAddBtn）のみを対象
    const isQuickAddButton = btn.classList.contains(
      "p-itemBottom__quickAddBtn",
    );

    // ★ Quick Addボタンでない場合は処理をスキップ
    if (!isQuickAddButton) {
      return;
    }

    // ★ イベント伝播を停止して重複実行を防ぐ
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    // 連打防止
    if (btn.dataset.processing === "1") {
      return;
    }
    btn.dataset.processing = "1";

    // ★ Quick Addボタンの場合、フォームは.p-itemBottom__quickAddForm内にある
    const form =
      btn.closest(".p-itemBottom__quickAddForm") ||
      btn.closest(".product-buy-buttons--form");
    if (!form) {
      btn.dataset.processing = "0";
      return;
    }

    // ローディング表示
    const textEl = btn.querySelector(".btn-text");
    const spinnerEl = btn.querySelector(".product--spinner");
    const showLoading = (loading) => {
      if (textEl) textEl.style.display = loading ? "none" : "block";
      if (spinnerEl) spinnerEl.style.display = loading ? "block" : "none";
      btn.disabled = loading;
    };
    showLoading(true);

    try {
      const formData = new FormData(form);
      let variantId = formData.get("id");
      const quantity = parseInt(formData.get("quantity") || "1", 10);

      // ★ variant IDが取得できない場合、data属性やinput[name="id"]から取得を試みる
      if (!variantId) {
        const idInput = form.querySelector('input[name="id"]');
        if (idInput) {
          variantId = idInput.value;
        }
      }

      if (!variantId) {
        console.error("[Quick Add Debug] Variant ID not found!");
        throw new Error("商品IDが見つかりません");
      }

      // ★ 商品ハンドルを取得して商品JSONデータをフェッチ
      const productHandle = form.dataset.handle;

      if (!productHandle) {
        console.error("[Quick Add Debug] Product handle not found!");
        throw new Error("商品ハンドルが見つかりません");
      }

      // 商品JSONを取得
      const productResponse = await fetch(`/products/${productHandle}.js`);
      const productData = await productResponse.json();

      // ★ バリエーションが複数ある場合は、Quick Addドロワーを開くだけで、カート追加しない
      if (productData.variants.length > 1) {
        btn.dataset.processing = "0";
        showLoading(false);
        return;
      }

      // バリアント情報を取得
      const variant = productData.variants.find(
        (v) => String(v.id) === String(variantId),
      );
      if (!variant) {
        console.error("[Quick Add Debug] Variant not found!");
        throw new Error("バリアント情報が見つかりません");
      }

      // 価格（セント単位）を円に変換
      const price = variant.price; // セント単位

      // メタフィールドからdonation_perを取得
      const donationPer = productData.metafields?.custom?._donation_per || 0.01; // デフォルト1%

      // 税抜き価格 = 税込価格 / 1.1
      const priceWithoutTax = Math.floor(price / 1.1);
      // 支援金額 = donation_per × 税抜き価格 × 数量
      const donationAmount = Math.floor(
        donationPer * priceWithoutTax * quantity,
      );

      const payload = {
        id: variantId,
        quantity: quantity,
      };

      payload.properties = {
        支援先: "BEAUTH基金（森林保全支援）",
        支援金額:
          donationAmount > 0 ? `¥${Math.floor(donationAmount / 100)}` : "¥0",
      };

      // Ajaxでカートに追加
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify(payload),
        credentials: "same-origin",
      });

      if (!res.ok) {
        const err = await res.json();
        console.error("[Quick Add Debug] Cart add failed:", err);
        throw new Error(err.description || "Failed to add to cart");
      }

      // カートカウントの更新ロジック
      const inc = Math.max(
        1,
        parseInt(String(payload.quantity || "1"), 10) || 1,
      );
      const headerCart = document.getElementById("header_cart");
      let currentTotal = 0;

      if (headerCart) {
        const raw =
          headerCart.getAttribute("data-item-count") ||
          headerCart.dataset.itemCount ||
          "";
        currentTotal = raw === "" ? 0 : parseInt(raw, 10) || 0;
      } else {
        const badge = document.querySelector(".cart--external--total-items");
        if (badge) {
          const raw = (badge.textContent || "").replace(/[^\d]/g, "");
          currentTotal = raw === "" ? 0 : parseInt(raw, 10) || 0;
        }
      }

      const nextTotal = currentTotal + inc;
      document
        .querySelectorAll(".cart--external--total-items")
        .forEach((el) => {
          el.textContent = String(nextTotal);
          if (nextTotal > 0) {
            el.style.display = "flex";
            el.classList?.remove("is-hidden", "hidden");
            el.setAttribute("aria-hidden", "false");
          }
        });
      if (headerCart) {
        headerCart.setAttribute("data-item-count", String(nextTotal));
        headerCart.dataset.itemCount = String(nextTotal);
      }

      // 完了トースト表示
      showCartToastAtButton(btn);
      showLoading(false);

      // 処理完了
      setTimeout(() => {
        btn.dataset.processing = "0";
      }, 3000);
    } catch (err) {
      console.error("[Quick Add Debug] Error occurred:", err);
      alert("カートに追加できませんでした：" + err.message);
      showLoading(false);
      btn.dataset.processing = "0";
    }
  });

  // ============================================================
  // Quick Addモーダル: バリエーション未選択時はカート追加ボタンを無効化
  // ============================================================
  (function setupQuickAddVariantRequired() {
    const SELECT_VARIANT_TEXT = "商品を選択してください";
    const DRAWER_VIEW_SELECTOR = '[data-view="product-form"]';
    const FORM_SELECTOR = "featured-product-root.product--form";

    function getVisibleProductForm() {
      const drawer = document.querySelector(DRAWER_VIEW_SELECTOR);
      if (!drawer) return null;
      const forms = drawer.querySelectorAll(FORM_SELECTOR);
      return (
        Array.from(forms).find((f) => {
          if (f.style.display === "none") return false;
          const cs = window.getComputedStyle(f);
          return cs.display !== "none" && cs.visibility !== "hidden";
        }) || null
      );
    }

    function getOptionContainers(formRoot) {
      const optionsRoot = formRoot.querySelector(".product-options--root");
      if (!optionsRoot) return [];
      return Array.from(
        optionsRoot.querySelectorAll(".product-options--option[data-index]"),
      );
    }

    function isAllOptionsSelected(formRoot) {
      const containers = getOptionContainers(formRoot);
      if (!containers.length) return true;
      return containers.every((c) => {
        const checked = c.querySelector("input.radios--input:checked");
        return !!checked && !checked.disabled;
      });
    }

    function getCtaButtons(formRoot) {
      return formRoot.querySelectorAll(".product-buy-buttons--cta");
    }

    function disableButton(btn) {
      btn.setAttribute("disabled", "disabled");
      btn.classList.add("is-variant-required-disabled");
      btn.dataset.qaVariantRequired = "true";
      const ctaText = btn.querySelector(".product-buy-buttons--cta-text");
      if (ctaText && !ctaText.dataset.qaOriginalText) {
        ctaText.dataset.qaOriginalText = ctaText.textContent;
        ctaText.textContent = SELECT_VARIANT_TEXT;
      }
    }

    // バリエーション要件のフラグ・ラベルのみ解除する。
    // disabled 属性そのものは在庫切れ等の本来のロジック (updateView) に任せるため触らない。
    function clearVariantRequiredFlag(btn) {
      if (btn.dataset.qaVariantRequired !== "true") return;
      delete btn.dataset.qaVariantRequired;
      btn.classList.remove("is-variant-required-disabled");
      const ctaText = btn.querySelector(".product-buy-buttons--cta-text");
      if (ctaText && ctaText.dataset.qaOriginalText) {
        if (ctaText.textContent === SELECT_VARIANT_TEXT) {
          ctaText.textContent = ctaText.dataset.qaOriginalText;
        }
        delete ctaText.dataset.qaOriginalText;
      }
    }

    function updateButtonState(formRoot) {
      if (!formRoot) return;
      const containers = getOptionContainers(formRoot);
      if (!containers.length) return; // 単一バリエーションは対象外
      const allSelected = isAllOptionsSelected(formRoot);
      getCtaButtons(formRoot).forEach((btn) => {
        if (allSelected) {
          clearVariantRequiredFlag(btn);
        } else {
          disableButton(btn);
        }
      });
    }

    function clearSelections(formRoot) {
      formRoot.querySelectorAll("input.radios--input").forEach((r) => {
        r.checked = false;
      });
    }

    function resetForm(formRoot) {
      if (!formRoot) return;
      if (!getOptionContainers(formRoot).length) return;
      clearSelections(formRoot);
      updateButtonState(formRoot);
    }

    // 1) ドロワーが開くたびに、表示中のフォームの選択をクリア＆ボタンを無効化
    window.addEventListener("theme:offCanvas:rightOpening", () => {
      // initForm で display 切り替えが完了している前提だが、念のため次フレームに回す
      requestAnimationFrame(() => {
        const formRoot = getVisibleProductForm();
        if (!formRoot) return;
        resetForm(formRoot);
      });
    });

    // 2) ラジオ選択が変わったら、ドロワー内フォームの場合のみボタン状態を再評価
    document.addEventListener("change", (e) => {
      const target = e.target;
      if (
        !target ||
        !target.classList ||
        !target.classList.contains("radios--input")
      )
        return;
      const formRoot = target.closest(FORM_SELECTOR);
      if (!formRoot) return;
      // ドロワー内に存在するフォームのみが対象
      if (!formRoot.closest(DRAWER_VIEW_SELECTOR)) return;
      updateButtonState(formRoot);
    });
  })();
});
